export default class CAIA0040RequestModel {}
